export class FundPerformance {
  id: number;
  uuid: string;
  fundUuid: string;
  period: Date;
  comment: string;
  totalCommitment: number;
  contribution: number;
  realizedGain: number;
  distribution: number;
  carryDistribution: number;
  escrow: number;
  totalCost: number;
  totalFmv: number;
  tvpi?: number;
  dpi?: number;
  netIrr: number;
  activeIrr?: number;
  realizedIrr?: number;
  unrealized: number;
  activeCost: number;
  activeFmv: number;
  realizedCost: number;
  realizedFmv: number;
  totalCompanyAmount?: number;
  activeCompaniesAmount?: number;
  realizedCompaniesAmount?: number;
  escrowCompaniesCount?: number;
  calculatedGrossIrr?: number;
  blocked: boolean;
  isVisible: boolean;
  initialCost?: number;
  initialFmv?: number;
  followOnFmv?: number;
  followOnCost?: number;
  carryInterest: number;
  carryInterestPercent: number;
  netIrrAfterCarry: number;
  mgmFees: number;
  totalExpenses: number;
  aggregatedOrgExpenses: number;
  navBeforeCarry?: number;
  isBasedOnPrognosis: boolean;
  expectedFutureInv: number = 0;
  expectedOpEx: number;
  irrCalculated: number;
  irrCalculatedAfterCarry: number;
  isIrrCanBeCalculated?: boolean;
  isTotalExpensesPositive: boolean;
  isPublished?: boolean;
}

